import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

// Views
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import WallView from '../views/WallView.vue'
import GroupsView from '../views/GroupsView.vue'
import GroupView from '../views/GroupView.vue'
import ProfileView from '../views/ProfileView.vue'
import UsersView from '../views/UsersView.vue'
import FriendsView from '../views/FriendsView.vue'
import PageView from '../views/PageView.vue'
import FaqView from '../views/FaqView.vue'
import AdminView from '../views/AdminView.vue'
import BlogView from '../views/BlogView.vue'
import BlogPostView from '../views/BlogPostView.vue'
import ForgotPassword from '../components/ForgotPassword.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { guest: true }
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPassword,
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: { guest: true }
  },
  {
    path: '/wall',
    name: 'wall',
    component: WallView,
    meta: { requiresAuth: true }
  },
  {
    path: '/groups',
    name: 'groups',
    component: GroupsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/groups/:id',
    name: 'group',
    component: GroupView,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile/:username',
    name: 'profile',
    component: ProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'users',
    component: UsersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/friends',
    name: 'friends',
    component: FriendsView,
    meta: { requiresAuth: true }
  },
  // Static pages (public - no auth required)
  {
    path: '/page/:slug',
    name: 'page',
    component: PageView
  },
  {
    path: '/about',
    redirect: '/page/about'
  },
  {
    path: '/terms',
    redirect: '/page/terms'
  },
  {
    path: '/privacy',
    redirect: '/page/privacy'
  },
  {
    path: '/faq',
    name: 'faq',
    component: FaqView
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: { requiresAuth: true }
  },
  {
    path: '/blog',
    name: 'blog',
    component: BlogView
  },
  {
    path: '/blog/:slug',
    name: 'blogPost',
    component: BlogPostView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Helper to get favorite group from localStorage
const getFavoriteGroupId = () => {
  try {
    const stored = JSON.parse(localStorage.getItem('accessibility_settings') || '{}')
    return stored.favoriteGroupId || null
  } catch {
    return null
  }
}

// Navigation guards
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else if (to.meta.guest && isAuthenticated) {
    // After login: redirect to favorite group if set, otherwise wall
    const favoriteGroupId = getFavoriteGroupId()
    if (favoriteGroupId) {
      next({ path: `/groups/${favoriteGroupId}` })
    } else {
      next({ name: 'wall' })
    }
  } else {
    next()
  }
})

export default router